import type {
  PDFConvertFunction,
  PDFMergeFunction,
  PDFPlotFunction,
  PDFRasterizeFunction,
  PDFSplitFunction,
} from "@pdfking/renderer-api"

export const PDFConvert: PDFConvertFunction = async (input, resolution) => {
  const { PDFConvert } = await import("../utils/Proxy")
  return PDFConvert(input, resolution)
}

export const PDFPlot: PDFPlotFunction = async (page, partial = {}) => {
  const { PDFPlot } = await import("../utils/Proxy")
  return PDFPlot(page, partial)
}

export const PDFMerge: PDFMergeFunction = async function* (pages) {
  const { PDFMerge } = await import("../utils/Proxy")
  yield* PDFMerge(pages)
}

export const PDFRasterize: PDFRasterizeFunction = async function* (
  input,
  image_resolution,
  rangeFn
) {
  const { PDFRasterize } = await import("../utils/Proxy")
  yield* PDFRasterize(input, image_resolution, rangeFn)
}

export const PDFSplit: PDFSplitFunction = async function* (input, rangeFn) {
  const { PDFSplit } = await import("../utils/Proxy")
  yield* PDFSplit(input, rangeFn)
}
